module.exports = __webpack_public_path__ + "img/sy4.b47864af.png";